import { Component, OnInit,Pipe, PipeTransform } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/data-services/authentication.service';
import { UserService } from 'src/app/data-services/user.service';
import { MessageService } from 'src/app/data-services/message.service';
import { PostService } from 'src/app/data-services/post.service';
import { first } from 'rxjs/operators';
import { NgForm, FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import {formatDate} from '@angular/common';
import { pipe } from 'rxjs';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  token: string;
  queryString:string;
  queryString2:string;
  curPage : number;
  pageSize : number;
  pageSize2 : number;
  formGroup: FormGroup;
  searchForm: FormGroup;
  searchForm2: FormGroup;
  language = '';
  direction = '';
  submitted: boolean;
  errorFlag: boolean;
  visible: boolean;
  defaultLanguage;
  delpost:any;
  Clubnews:any;
  posts2 : any;
  feednews:any;
  statususer1:any;
  statususer2:any;
  userrols:any;
  currentUser: any;
  users:any;
  views:any;
  deluser :any;
  comments:any;
  comnew:any;
  data:any;
  data22:any;
  id: any;
  role: any;
  commentusers:any;
  selectNews: any = {};
  slider: any = {};
  searchData: any = {};
  userData: any = [];
  isLoaderVisible = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private messageService: MessageService,
    private postService : PostService,
    private http:HttpClient,
    private activatedRoute: ActivatedRoute,
    public fb:FormBuilder
  ){
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.messageService.selectedLanguage.subscribe(res => {
      console.log(res);
      this.language = res.lang;
      this.direction = res.dir;
    });
    this.curPage = 1;
    this.pageSize = 25; 
    this.pageSize2 = 5; 
  }
  ngOnInit(): void {
    this.defaultLanguage = JSON.parse(localStorage.getItem('language'));
    this.direction = this.defaultLanguage.dir;
    this.language = this.defaultLanguage.lang;
    this.route.queryParams.subscribe(params => {
      this.id = params['id'];
    });
    this.getusers();
    this.searchForm = this.formBuilder.group({
      email: ['', Validators.required],
    });
    this.searchForm2 = this.formBuilder.group({
      fullName: ['', Validators.required],
    });
    this.search();
    this.search2();
    this.getuserstatus1();
    this.getuserstatus2();
    this.getuserrols();
    this.getallfeeds();
  }
  getProfile() {
    const data = {
      id: this.currentUser.success.user.id,
      role: this.currentUser.success.user.role,
    };
    this.userService.getProfile(data).subscribe((res: any) => {
      this.userData = res;
      this.messageService.sendMessage(this.userData);
      localStorage.setItem('userData', JSON.stringify(this.userData));
    });
  }
  getusers()
  {
    this.isLoaderVisible = true;
    this.userService.getAllUsers().subscribe(
      res =>this.users =res
    );
    console.log(this.users);
    this.isLoaderVisible = false;
  }
  numberOfPages(){
    return Math.ceil(this.users.length / this.pageSize);
  }
   numberOfPages2(){
    return Math.ceil(this.feednews.length / this.pageSize2);
  }
  get f() {
    return this.searchForm.controls;
  }
  search() {
  this.isLoaderVisible = true;
  var fd2:any = new FormData();
    fd2.append('email', this.searchForm.get('email').value);
  this.userService.getsearchuser(fd2).subscribe(
    succuss => {
      this.data = succuss;
      this.isLoaderVisible = false;
      console.log(this.data);
    },
    error => {
      console.log(error);
      this.isLoaderVisible = false;
    }
  );
}
search2() {
  this.isLoaderVisible = true;
  var fd1:any = new FormData();
    fd1.append('fullName', this.searchForm2.get('fullName').value);
  this.postService.getfindfeed(fd1).subscribe(
    succuss => {
      this.data22 = succuss;
      this.isLoaderVisible = false;
      console.log(this.data22);
    },
    error => {
      console.log(error);
      this.isLoaderVisible = false;
    }
  );
}

deleteuser(id:number){
  if (confirm('Are you sure you want to delete this user?')) {
  this.isLoaderVisible = true;
  const data={
    userId:id
  }
  this.userService.deleteUser(data).subscribe(
    data=>{
        this.deluser = data;
        this.isLoaderVisible = false;
        this.searchForm = this.formBuilder.group({
          email: ['', Validators.required],
        });
        this.ngOnInit();
        this.toastrService.success('User deleted !!', 'Message!');
    });
  }
  else
  {
    this.ngOnInit();
  }
}
getuserstatus1(){
  const data={
    status:1
  };
  this.userService.getuserstatus(data).subscribe(
    datauser=> this.statususer1 =datauser
  );
  console.log(this.statususer1);
}
getuserstatus2(){
  const data={
    status:0
  };
  this.userService.getuserstatus(data).subscribe(
    datauser=> this.statususer2 =datauser
  );
  console.log(this.statususer2);
}
getuserrols(){
  this.userService.getuserrols().pipe(first()).subscribe(
    datauserrols=> this.userrols =datauserrols
  );
  console.log(this.userrols);
}
getallfeeds()
{
  const data={
    user_id:this.currentUser.success.user.id
  };
  this.postService.getNewsFeed(data).subscribe(
    data=> this.feednews =data
  );
}
deletepost(id:number){
  if (confirm('Are you sure you want to delete this user?')) {
  this.isLoaderVisible = true;
  const data={
    postId:id
  }
  this.postService.deletePost(data).subscribe(
    data=>{
        this.delpost = data;
        this.isLoaderVisible = false;
        this.searchForm = this.formBuilder.group({
          email: ['', Validators.required],
        });
        this.ngOnInit();
        this.toastrService.success('User deleted !!', 'Message!');
    });
  }
  else
  {
    this.ngOnInit();
  }
}
}
